import { faAirplay } from '@fortawesome/pro-solid-svg-icons';
import { useFeatureGate } from '@statsig/react-bindings';

import { Menu, MenuToggleButton } from '@growtherapy/sprout-ui';

import { ControlPanelButton } from '../../components/ControlPanelButton';
import { MENU_Z_INDEX_CLASSNAME } from '../../components/constants';
import { useVideoPlatform } from '../../hooks/useVideoPlatform';
import {
  ScreenShareControlWrapper,
  ScreenShareMenuItemsWrapper,
} from '../../session/controls/ScreenShareControlWrapper';
import { WhiteboardControlMenuItemWrapper } from '../../session/controls/WhiteboardControlWrapper';
import { whiteboardEnabledGate } from '../../statsig/gates';
import { VideoPlatform } from '../../video-sdk';

export function SessionModeControlButtonWrapper({ className }: { className?: string }) {
  const { value: isWhiteboardingEnabled } = useFeatureGate(whiteboardEnabledGate);
  const videoPlatformIsZoom = useVideoPlatform() === VideoPlatform.Zoom;

  // Whiteboarding is not scoped for the initial Zoom launch, but will be added
  // later.
  if (videoPlatformIsZoom || !isWhiteboardingEnabled) {
    return <ScreenShareControlWrapper />;
  }

  return (
    <Menu
      className={className}
      menuClassName={MENU_Z_INDEX_CLASSNAME}
      placement='top'
      ariaLabel='Screen sharing and whiteboarding options'
      toggleButtonTooltip='Screen share or whiteboard'
      toggleButton={
        <MenuToggleButton<typeof ControlPanelButton>
          as={ControlPanelButton}
          visibleCaret={false}
          aria-label='View screen sharing and whiteboarding options'
          iconDefinition={faAirplay}
          shouldOverrideClassName
        />
      }
    >
      <ScreenShareMenuItemsWrapper />
      <WhiteboardControlMenuItemWrapper />
    </Menu>
  );
}
